import { render, staticRenderFns } from "./NotificationsTrigger.vue?vue&type=template&id=68bd6ce8&scoped=true&"
import script from "./NotificationsTrigger.vue?vue&type=script&lang=ts&"
export * from "./NotificationsTrigger.vue?vue&type=script&lang=ts&"
import style0 from "./NotificationsTrigger.vue?vue&type=style&index=0&id=68bd6ce8&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68bd6ce8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBadge } from 'vuetify/lib/components/VBadge';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VFadeTransition } from 'vuetify/lib/components/transitions';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VBadge,VBtn,VFadeTransition,VIcon,VImg})
